// extracted by mini-css-extract-plugin
export default {"mapHistory":"LocationHistory_mapHistory__AwCPL","popup":"LocationHistory_popup__7b4NZ"};